export default __webpack_public_path__ + "static/media/sign-up-with-google.2d3333e8.png";